export default defineNuxtRouteMiddleware(async to => {
  if (!to.meta.auth) return;

  const { user, loggedIn, refreshSession, loading } = useAuth();
  const localeRoute = useLocaleRoute();

  if (loggedIn.value) return;

  // Retry to get user
  if (!loading.value) {
    await refreshSession();
  }

  if (!loggedIn.value) {
    return navigateTo(
      localeRoute({
        path: "/login",
        query: {
          redirect: to.fullPath,
        },
      }),
      { replace: true },
    );
  }

  if (!user.value?.emailVerified) {
    return navigateTo(
      localeRoute({
        path: "/verify-email",
        query: { returnTo: to.fullPath },
      }),
      { replace: true },
    );
  }
});
